// extracted by mini-css-extract-plugin
export default {"parent-mode":"circular-progress-bar_parent-mode__tC2rQ","progressBar":"circular-progress-bar_progressBar__EY-iN","text":"circular-progress-bar_text__pnwRW"};